// frontend/src/components/code-editor/CodeEditorPanel.tsx
//
// Basit bir textarea tabanlı editör. Sözdizimi vurgulamalı tam bir kod
// editörü (örn. CodeMirror/Monaco) istenirse bu component'in içi
// değiştirilebilir — dışa açılan prop arayüzü aynı kalır.

interface CodeEditorPanelProps {
  code: string;
  onChange: (code: string) => void;
  onRun: () => void;
  onReset: () => void;
  isRunning: boolean;
}

export function CodeEditorPanel({ code, onChange, onRun, onReset, isRunning }: CodeEditorPanelProps) {
  function handleKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    // Tab tuşu ile girinti — varsayılan davranış (focus değiştirme) yerine 4 boşluk ekler
    if (e.key === 'Tab') {
      e.preventDefault();
      const target = e.currentTarget;
      const start = target.selectionStart;
      const end = target.selectionEnd;
      const newValue = code.slice(0, start) + '    ' + code.slice(end);
      onChange(newValue);
      requestAnimationFrame(() => {
        target.selectionStart = target.selectionEnd = start + 4;
      });
    }
    // Ctrl/Cmd + Enter ile çalıştır
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      e.preventDefault();
      onRun();
    }
  }

  return (
    <div className="card code-editor-card">
      <div className="code-editor-toolbar">
        <div className="code-editor-toolbar-left">
          <span className="code-editor-filename">main.py</span>
          <span className="lesson-badge primary">Python</span>
        </div>
        <div className="code-editor-toolbar-right">
          <button type="button" className="lesson-btn secondary sm" onClick={onReset} disabled={isRunning}>
            🔄 Sıfırla
          </button>
          <button type="button" className="lesson-btn primary sm" onClick={onRun} disabled={isRunning}>
            {isRunning ? '⏳ Çalışıyor...' : '▶️ Çalıştır'}
          </button>
        </div>
      </div>
      <div className="code-editor-body">
        <div className="code-editor-dots">
          <span className="red" />
          <span className="yellow" />
          <span className="green" />
        </div>
        <textarea
          className="code-editor-textarea"
          value={code}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          spellCheck={false}
          aria-label="Python kod editörü"
        />
      </div>
    </div>
  );
}
